var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4658 1C14.3431 1 13.9163 1.89861 14.0032 3.63947C14.0608 4.78706 14.4474 7.98646 12.8277 9.60771C11.3171 11.1191 10.8777 10.9848 9.15646 12.9364C7.43594 14.8873 6.00183 14.486 3.9942 14.3135C1.47214 14.0973 2.33136 28.0994 4.10889 27.8566C5.37062 27.6841 8.23888 27.3399 8.69767 27.3399C9.15646 27.3399 12.3028 29.7783 15.0647 29.8076C19.5381 29.8541 22.0052 29.0613 22.0052 29.0613L23.3163 26.0858L23.7549 17.0135L21.6604 12.6492C21.6604 12.6492 18.8499 13.1082 18.0469 11.8458C17.244 10.5835 18.6781 9.03391 18.6781 5.41859C18.6781 1.80332 16.0393 1 15.4658 1Z",
    fill: "url(#paint0_linear_2093_6820)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1612 29.0352L21.9909 28.4141C21.4869 28.3605 20.8383 28.5901 19.9527 28.5831C15.7226 28.5504 11.6788 27.3353 9.94369 25.961C8.80711 25.061 8.30867 23.8633 7.50577 24.2076C6.51515 24.6326 3.70462 25.2933 2.6709 23.9844C2.96008 26.2239 3.47588 27.9432 4.10849 27.857C5.37023 27.6845 8.23848 27.3402 8.69727 27.3402C9.15606 27.3402 12.2148 29.7147 15.0643 29.8079C18.7507 29.9282 22.0249 29.2932 22.0249 29.2932L22.1612 29.0352Z",
    fill: "url(#paint1_linear_2093_6820)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78656 15.1976C7.45008 15.6566 8.50673 14.8971 9.35693 13.8636C10.2016 12.837 10.9342 11.9265 13.0566 10.5494C15.1789 9.1723 14.9064 5.38456 14.734 4.12219C14.5616 2.85982 14.6763 1 15.4667 1C14.344 1 13.9172 1.89861 14.0041 3.63947C14.0618 4.78711 14.4483 7.98646 12.8286 9.60771C11.318 11.1191 10.8786 10.9848 9.15742 12.9364C7.4369 14.8874 6.00275 14.486 3.99512 14.3136C3.99584 14.749 4.12304 14.7385 5.78656 15.1976Z",
    fill: "url(#paint2_linear_2093_6820)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.047 11.8459C17.2441 10.5835 18.6782 9.03391 18.6782 5.41859C18.6782 1.80332 16.04 1 15.4658 1C15.315 1 15.1808 1.01669 15.0605 1.04868C17.4005 1.19544 18.8096 4.14788 18.0032 7.19217C17.349 9.66263 17.023 11.6435 18.0915 12.805C18.7824 13.5569 20.1568 13.4288 21.6611 12.6492C21.6604 12.6492 18.8499 13.1082 18.047 11.8459Z",
    fill: "url(#paint3_linear_2093_6820)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2046 13.1338C16.8281 13.5929 13.3516 14.673 10.7184 17.0621C4.04478 23.1165 15.4385 23.8753 17.7916 29.0534C18.2414 30.0432 20.8705 23.8628 20.8705 23.8628L21.7207 22.4314L19.264 15.886L18.2046 13.1338Z",
    fill: "url(#paint4_linear_2093_6820)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4068 13.6582C17.0304 14.1173 11.4072 17.7214 11.4072 19.5012C11.4072 24.6376 15.3015 22.1025 17.4065 28.1632C17.6978 29.0027 18.7273 29.7087 18.7273 29.7087C19.5803 29.0124 20.8712 23.8628 20.8712 23.8628L21.7214 22.4315L19.2647 15.886L18.4068 13.6582Z",
    fill: "url(#paint5_linear_2093_6820)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5841 29.4009L24.2188 26.3873L24.7993 13.7977L18.2042 13.1328C16.6902 13.9479 16.515 15.0629 17.0774 16.8531C17.3138 17.6064 16.3523 17.822 16.2905 20.0163C16.2474 21.5374 17.2428 21.5444 17.2428 21.9964C17.2428 22.4485 16.7472 22.4082 16.5824 23.7179C16.3475 25.5916 17.9157 25.6278 17.9157 26.0284C17.9157 26.429 17.0447 26.6668 17.0983 28.1942C17.1664 30.1312 13.571 29.7396 11.14 27.9772C10.1417 27.2532 9.27069 27.1788 8.59082 27.3429C8.63323 27.3408 8.66939 27.3394 8.69649 27.3394C9.15528 27.3394 12.237 29.8071 15.0635 29.8071C18.369 29.8071 20.6547 29.6138 21.5841 29.4009Z",
    fill: "url(#paint6_linear_2093_6820)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1897 13.9639C20.1535 13.9639 19.035 15.9544 19.8094 17.4839C20.5838 19.0133 18.3753 21.038 18.6047 22.0346C18.8341 23.0313 19.2359 25.5539 19.5508 25.9713C19.8664 26.3885 19.0343 27.3351 19.0343 27.3351L21.6155 27.6509L24.0242 26.5881L23.938 19.3013L24.1959 14.7387L22.1897 13.9639Z",
    fill: "url(#paint7_linear_2093_6820)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15693 12.9369C8.03911 14.2041 7.04223 14.4789 5.93066 14.4684C6.25116 14.9859 6.47428 15.5514 6.45135 16.1043C6.39086 17.5538 6.70995 19.3405 6.95396 17.4821C7.13956 16.0667 8.09888 14.3175 9.25286 12.8291C9.2216 12.8646 9.19028 12.8993 9.15693 12.9369Z",
    fill: "url(#paint8_linear_2093_6820)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7322 12.5925C21.3249 12.5007 16.9968 12.3644 16.9001 14.8877C16.8306 16.7176 18.1278 17.3179 20.1341 17.3943C22.1403 17.4709 23.1434 17.5091 23.9741 17.5404C24.8048 17.5717 27.4187 17.5564 27.4444 15.3468C27.4764 12.5863 23.7322 12.5925 23.7322 12.5925Z",
    fill: "url(#paint9_linear_2093_6820)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7728 21.7134C19.1277 21.6946 17.2111 22.178 17.0318 23.3959C16.8907 24.3536 17.3794 25.5909 19.0471 25.8831C21.1597 26.253 24.68 26.4471 25.9952 25.9547C26.5826 25.7349 27.095 25.1194 27.1221 24.1867C27.1492 23.254 26.4568 21.9972 24.9518 21.9533C23.4468 21.9103 22.6626 21.9332 21.8048 21.8316C20.7732 21.7106 20.2886 21.7287 19.7728 21.7134Z",
    fill: "url(#paint10_linear_2093_6820)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0999 25.9707C18.3686 25.9707 17.4648 26.6162 17.4648 27.6921C17.4648 28.7681 17.7443 29.5645 19.3147 29.8656C20.8851 30.1668 23.4015 29.9087 24.3477 29.6076C25.0852 29.3725 25.3585 28.6825 25.3585 27.5419C25.3585 26.4013 24.6494 26.2016 23.875 26.2016C23.1006 26.2016 22.1607 26.3428 21.624 26.315C20.1252 26.2357 19.8312 25.9707 19.0999 25.9707Z",
    fill: "url(#paint11_linear_2093_6820)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5278 13.1014C21.4257 13.0214 17.6461 12.8997 17.5703 14.8944C17.5153 16.3411 18.6499 16.8196 20.4017 16.8864C22.1535 16.9531 26.7624 17.0373 26.7777 15.2909C26.7965 13.1083 23.5278 13.1014 23.5278 13.1014Z",
    fill: "url(#paint12_linear_2093_6820)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9668 22.2287C19.4051 22.2127 17.8327 22.3463 17.6819 23.5098C17.5796 24.2972 17.9877 25.3085 19.4399 25.5498C21.28 25.8559 24.3443 26.02 25.4892 25.6187C26.0001 25.4392 26.4458 24.9364 26.4673 24.172C26.4896 23.4076 25.7854 22.4707 24.4757 22.4325C23.166 22.3942 22.4687 22.5159 21.7214 22.4311C20.8233 22.3303 20.4159 22.2412 19.9668 22.2287Z",
    fill: "url(#paint13_linear_2093_6820)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.413 26.3633C18.7804 26.3633 17.999 26.8828 17.999 27.7494C17.999 28.6161 18.2409 29.2573 19.5993 29.4993C20.9576 29.7414 23.1342 29.5341 23.9531 29.2914C24.5905 29.1022 24.8276 28.5465 24.8276 27.6277C24.8276 26.7089 24.2138 26.549 23.5436 26.549C22.8735 26.549 22.0609 26.663 21.5965 26.6401C20.2993 26.5768 20.0449 26.3633 19.413 26.3633Z",
    fill: "url(#paint14_linear_2093_6820)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.028 14.8958C19.0802 13.5215 20.1757 12.8628 21.5598 12.5596C19.3505 12.611 16.9717 13.0242 16.9001 14.8875C16.8306 16.7174 18.1278 17.3176 20.134 17.3941C20.3551 17.4025 20.5629 17.4108 20.7604 17.4177C19.6342 17.0881 18.9731 16.3445 19.028 14.8958Z",
    fill: "url(#paint15_linear_2093_6820)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2164 12.8076C17.931 13.0886 16.9453 13.6965 16.9001 14.8865C16.8424 16.4076 17.7301 17.0788 19.1837 17.3062C16.2349 16.1287 17.2929 13.2284 19.2164 12.8076Z",
    fill: "url(#paint16_linear_2093_6820)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7933 27.2656C15.4534 28.0467 13.8357 28.0961 12.1798 27.3748C10.524 26.6543 9.45759 25.4364 9.79753 24.6547C10.1375 23.8736 11.7551 23.8243 13.411 24.5455C15.0662 25.2667 16.1332 26.4846 15.7933 27.2656Z",
    fill: "url(#paint17_radial_2093_6820)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5367 15.2638C25.5201 16.3196 24.1089 16.8204 22.5649 16.9143C21.3025 16.9908 19.901 16.0971 19.9372 15.0656C19.9734 14.0341 20.1569 13.1202 22.7804 13.2114C24.3265 13.2649 25.5527 14.2323 25.5367 15.2638Z",
    fill: "url(#paint18_radial_2093_6820)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.817 24.5451C25.808 26.0071 24.2015 25.7268 22.6575 25.8283C20.6999 25.9577 19.402 25.3477 19.4014 24.3155C19.4 23.2834 20.1445 22.5315 22.7701 22.5274C24.3169 22.5253 25.8282 22.6672 25.817 24.5451Z",
    fill: "url(#paint19_radial_2093_6820)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4015 28.2318C24.3938 29.4781 22.934 29.6478 21.5506 29.6486C20.1672 29.6499 18.6657 28.9162 18.665 28.0363C18.6643 27.1565 19.3296 26.5152 21.6772 26.5117C23.0598 26.5097 24.4112 26.6307 24.4015 28.2318Z",
    fill: "url(#paint20_radial_2093_6820)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8271 23.6927C19.0468 22.0283 20.3231 22.1257 21.7864 21.9532C20.102 21.8273 19.395 21.8093 19.395 21.8093C19.2379 21.7939 19.062 21.7933 18.8792 21.812C18.3321 21.9324 17.712 22.1814 17.3436 22.6488C17.2185 22.8268 17.117 23.0368 17.0502 23.2858C17.0433 23.322 17.0363 23.3589 17.0322 23.3964C16.9133 24.3577 17.3797 25.5915 19.0474 25.8836C19.288 25.926 19.5473 25.9657 19.8191 26.0026C19.9491 26.0192 20.0909 26.0366 20.2431 26.0561C20.2842 26.061 20.3252 26.0659 20.3669 26.0707C19.4465 25.636 18.6651 24.9161 18.8271 23.6927Z",
    fill: "url(#paint21_linear_2093_6820)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2341 21.7981C19.1208 21.7946 19.0005 21.7987 18.8775 21.8112C18.3255 21.933 17.6999 22.1854 17.3336 22.6605C17.2126 22.8358 17.1152 23.043 17.0499 23.2858C17.043 23.3219 17.0381 23.3581 17.0318 23.3957C16.8629 24.3422 17.3315 25.4579 18.7885 25.8272C16.3026 24.4556 17.3634 21.7994 19.2341 21.7981Z",
    fill: "url(#paint22_linear_2093_6820)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6809 26.2242C19.9462 26.1164 19.6445 25.9697 19.1008 25.9697C18.3695 25.9697 17.4658 26.6152 17.4658 27.6911C17.4658 28.082 17.5034 28.4353 17.625 28.7421C17.7488 28.9952 17.9288 29.2324 18.1756 29.4327C18.4467 29.6219 18.8151 29.7686 19.3149 29.8646C19.6507 29.9293 20.0303 29.9675 20.4279 29.9863C19.6605 29.5405 18.3605 29.3005 18.633 27.808C18.934 26.1596 19.9176 26.3822 20.6809 26.2242Z",
    fill: "url(#paint23_linear_2093_6820)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0682 25.9707C18.3431 25.9895 17.4658 26.6315 17.4658 27.6914C17.4658 28.677 17.7015 29.4281 18.9486 29.7787C17.0008 28.5267 17.6257 26.4145 19.0682 25.9707Z",
    fill: "url(#paint24_linear_2093_6820)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4448 15.3464C27.4476 15.0988 27.4198 14.8741 27.3676 14.6689C27.5615 15.5314 26.7934 16.3883 24.7573 16.8042C23.4079 17.0796 19.8244 17.4239 17.3447 16.439C17.88 17.0859 18.8651 17.3446 20.1344 17.3933C22.1407 17.4698 23.1438 17.5081 23.9745 17.5394C24.8053 17.572 27.4183 17.556 27.4448 15.3464Z",
    fill: "url(#paint25_linear_2093_6820)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1222 24.1287C27.1193 23.2023 26.4249 21.9969 24.9511 21.9545C23.4461 21.9114 22.662 21.9343 21.8042 21.8328C20.7732 21.7111 20.2887 21.7292 19.7729 21.7146C19.3829 21.7034 18.4208 21.821 17.7666 22.2278C18.5021 22.4831 19.7006 22.867 21.387 22.7592C25.428 22.4991 26.5778 22.988 27.1222 24.1287Z",
    fill: "url(#paint26_linear_2093_6820)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9055 17.5394C18.0456 17.522 16.6796 18.0283 16.6441 19.8151C16.6087 21.6012 18.1707 22.0268 18.8589 22.0408C19.5472 22.0547 21.9531 22.2188 24.9208 22.2779C27.8884 22.337 28.286 20.7436 28.3027 19.909C28.3194 19.0737 27.7904 17.5637 26.0052 17.5276C20.8436 17.4239 18.9055 17.5394 18.9055 17.5394Z",
    fill: "url(#paint27_linear_2093_6820)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3677 18.0575C18.6197 18.0429 17.4338 18.431 17.4067 19.8088C17.3789 21.1873 18.7379 21.5184 19.3358 21.5302C19.9343 21.542 22.026 21.6735 24.6058 21.7249C27.1855 21.7764 27.5283 20.5482 27.5408 19.9034C27.554 19.2593 27.465 18.0936 25.9127 18.0623C21.4268 17.9733 19.3677 18.0575 19.3677 18.0575Z",
    fill: "url(#paint28_linear_2093_6820)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4898 19.6424C18.576 17.8084 19.8558 17.8028 21.3004 17.4863C19.6111 17.4968 18.9055 17.5385 18.9055 17.5385C18.0456 17.5211 16.6796 18.0275 16.6441 19.8142C16.6087 21.6003 18.1707 22.0259 18.8589 22.0399C19.1071 22.0447 19.5791 22.0691 20.2186 22.1011C19.2649 21.7081 18.4265 20.9917 18.4898 19.6424Z",
    fill: "url(#paint29_linear_2093_6820)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7923 19.8326C26.8521 21.2931 25.2303 21.5679 23.6849 21.6416C22.1396 21.7153 20.4218 20.9343 20.3725 19.9035C20.3231 18.8728 21.0315 18.0869 23.6536 17.9596C25.199 17.8851 26.7158 17.9561 26.7923 19.8326Z",
    fill: "url(#paint30_radial_2093_6820)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.745 17.542C17.8857 17.5879 16.6776 18.136 16.6442 19.8142C16.6101 21.5127 18.0199 21.9808 18.7505 22.0343C15.9233 20.893 16.85 17.7103 18.745 17.542Z",
    fill: "url(#paint31_linear_2093_6820)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2989 19.7285C27.9263 22.3714 20.942 21.8874 17.168 21.3198C17.6776 21.8658 18.4353 22.0313 18.86 22.0404C19.5482 22.0543 21.9542 22.2184 24.9218 22.2775C27.8895 22.3367 28.2871 20.7432 28.3038 19.9086C28.3045 19.8516 28.3031 19.7911 28.2989 19.7285Z",
    fill: "url(#paint32_linear_2093_6820)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7997 25.6133C23.4469 25.6731 19.8675 26.1182 17.2578 24.7196C17.5491 25.2606 18.1129 25.7204 19.0465 25.8838C21.1591 26.2539 24.6794 26.4479 25.9946 25.9555C26.5821 25.7357 27.0944 25.1202 27.1215 24.1875C27.0346 24.9985 26.2623 25.5486 24.7997 25.6133Z",
    fill: "url(#paint33_linear_2093_6820)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2562 28.5508C24.3699 29.2254 22.8378 29.624 20.6271 29.2505C19.2619 29.0195 18.3261 28.941 17.7109 28.9243C17.957 29.3694 18.4318 29.6963 19.3161 29.866C20.8865 30.1671 23.4029 29.9091 24.349 29.6079C24.835 29.4521 25.1186 29.0988 25.2562 28.5508Z",
    fill: "url(#paint34_linear_2093_6820)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7568 26.724C19.3946 26.1272 20.1976 27.0126 21.9501 27.0126C23.77 27.0126 24.6376 26.2775 25.2841 26.9765C25.0811 26.3317 24.4999 26.2016 23.8764 26.2016C23.1019 26.2016 22.1621 26.3428 21.6247 26.315C20.126 26.2364 19.8326 25.9707 19.1013 25.9707C18.6279 25.9707 18.0829 26.2413 17.7568 26.724Z",
    fill: "url(#paint35_linear_2093_6820)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10933 27.8566C5.37102 27.6841 8.23927 27.3398 8.69806 27.3398C4.53821 24.3651 6.38806 18.038 7.92226 14.8379C8.13777 14.3886 8.27054 14.02 8.34218 13.707C6.9581 14.7628 5.6776 14.4582 3.99391 14.3135C1.47185 14.0972 2.33175 28.0993 4.10933 27.8566Z",
    fill: "url(#paint36_linear_2093_6820)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73323 24.9817C6.30294 24.4079 6.67555 25.6417 7.02033 26.5313C7.31301 27.288 5.06835 26.8408 3.35059 27.0265C3.57511 27.5808 3.83163 27.8945 4.11039 27.8562C5.37213 27.6838 8.24038 27.3395 8.69917 27.3395C8.05197 26.7894 7.16284 25.5555 6.73323 24.9817Z",
    fill: "url(#paint37_linear_2093_6820)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69683 27.3406C8.34022 27.0367 7.90993 26.5248 7.52268 26.0303C7.52268 26.0303 5.43444 27.0992 3.19531 26.5964C3.45323 27.4143 3.76326 27.904 4.10805 27.8566C5.37046 27.6849 8.23804 27.3406 8.69683 27.3406Z",
    fill: "url(#paint38_linear_2093_6820)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.608 6.38764C15.7905 6.56432 15.128 5.43481 14.754 4.11679C14.4481 3.03876 14.8638 1.6658 15.6667 1.51139C16.4697 1.35629 17.2107 1.34933 17.6535 3.63412C17.9135 4.97991 17.4074 6.21514 16.608 6.38764Z",
    fill: "url(#paint39_radial_2093_6820)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0696 25.971C18.6199 26.0183 18.2125 26.2596 17.9323 26.5914C17.648 26.926 17.5152 27.3627 17.5445 27.8016C17.5472 28.2432 17.614 28.6946 17.8642 29.0522C18.1124 29.4131 18.5295 29.628 18.9501 29.779C18.5163 29.6809 18.0623 29.5014 17.7717 29.121C17.477 28.7447 17.4089 28.2544 17.3943 27.8044C17.3748 27.344 17.5215 26.8543 17.8461 26.5149C18.161 26.172 18.6157 25.962 19.0696 25.971Z",
    fill: "#804B24"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3479 21.9678C18.0518 22.0965 17.7786 22.2724 17.5526 22.4915C17.3225 22.7078 17.2002 23.0041 17.1161 23.3046L17.1168 23.2997C17.0083 23.8478 17.1001 24.4313 17.422 24.8869C17.7362 25.3487 18.2464 25.6506 18.7886 25.8272C18.2304 25.7194 17.6681 25.4475 17.3149 24.9627C17.1404 24.7241 17.0194 24.4452 16.961 24.1538C16.902 23.8624 16.9291 23.5578 16.9833 23.2733L16.9847 23.2684C17.073 22.9526 17.2301 22.6362 17.4894 22.4227C17.7376 22.2022 18.042 22.0666 18.3479 21.9678Z",
    fill: "#804B24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7463 17.541C18.2145 17.6015 17.7001 17.8227 17.3338 18.1948C16.966 18.5669 16.7672 19.0795 16.7352 19.6018C16.6817 20.122 16.7658 20.6652 17.0634 21.0972C17.3567 21.5304 17.8363 21.8212 18.3494 21.9714C17.8238 21.8755 17.3011 21.616 16.9688 21.1646C16.6296 20.7167 16.5399 20.1304 16.5851 19.5893C16.6296 19.0454 16.843 18.4904 17.2531 18.1127C17.6591 17.7309 18.2104 17.5466 18.7463 17.541Z",
    fill: "#804B24"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.218 12.8076C18.6494 12.9634 18.0842 13.1783 17.6358 13.5477C17.1839 13.9149 16.9392 14.4817 16.9768 15.0625C16.9692 15.6391 17.1575 16.2275 17.5955 16.6093C18.0272 16.996 18.6097 17.1838 19.1846 17.3062C18.6014 17.2374 17.9945 17.0913 17.5197 16.6963C17.0338 16.3068 16.8273 15.6613 16.8266 15.0639C16.7953 14.4567 17.0686 13.821 17.5635 13.4579C18.0487 13.0858 18.6375 12.9106 19.218 12.8076Z",
    fill: "#804B24"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2588 24.7188C17.6502 25.3969 18.4023 25.7481 19.1454 25.8483C19.9018 25.9651 20.6637 26.0451 21.4277 26.0938C22.1903 26.1585 22.9556 26.1988 23.721 26.196C24.1033 26.1911 24.4864 26.1814 24.8666 26.1438C25.2469 26.1133 25.6306 26.0743 25.9963 25.954C25.2726 26.2259 24.4878 26.269 23.7231 26.2962C22.9542 26.3157 22.1847 26.2941 21.4172 26.244C20.6512 26.1779 19.8872 26.0813 19.1294 25.947C18.7485 25.8844 18.369 25.7662 18.0353 25.5631C17.703 25.3579 17.4305 25.0624 17.2588 24.7188Z",
    fill: "#804B24"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.168 21.3193C17.4613 21.6114 17.8388 21.8041 18.233 21.9022C18.625 22.0197 19.0373 21.994 19.4516 22.0128L21.9257 22.0844L24.3984 22.2061C25.2187 22.2562 26.0536 22.2673 26.8398 21.9982C26.0737 22.3251 25.2131 22.3515 24.3963 22.3062L21.9222 22.2347L19.4495 22.1122C19.0428 22.0844 18.6153 22.1039 18.2128 21.9724C17.8152 21.8479 17.4433 21.6288 17.168 21.3193Z",
    fill: "#804B24"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0056 17.5265C25.414 17.5279 24.8217 17.5446 24.2301 17.5391L22.4554 17.5425L20.6813 17.5669C20.0904 17.5703 19.4982 17.5738 18.9094 17.5975H18.9045C18.3226 17.5877 17.7199 17.7867 17.3008 18.2033C16.8732 18.6157 16.6716 19.216 16.6445 19.8141C16.6494 19.5143 16.6814 19.2118 16.7731 18.9218C16.8663 18.6324 17.0255 18.3619 17.2417 18.1441C17.6727 17.7011 18.2941 17.4814 18.9073 17.4799H18.9024C20.0877 17.4083 21.2715 17.4076 22.4554 17.4264C23.64 17.4396 24.8231 17.4619 26.0056 17.5265Z",
    fill: "#804B24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2093_6820",
    x1: 21.7536,
    y1: 15.1651,
    x2: 13.1249,
    y2: 15.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2093_6820",
    x1: 12.4397,
    y1: 27.1304,
    x2: 12.2662,
    y2: 22.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2093_6820",
    x1: 11.3348,
    y1: 10.0486,
    x2: 17.835,
    y2: 19.3422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2093_6820",
    x1: 6.63001,
    y1: 6.34591,
    x2: 23.2781,
    y2: 7.59278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2093_6820",
    x1: 6.31277,
    y1: 21.1475,
    x2: 28.1746,
    y2: 21.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2093_6820",
    x1: 2.78769,
    y1: 21.1804,
    x2: 45.978,
    y2: 22.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2093_6820",
    x1: 9.65064,
    y1: 26.8242,
    x2: 16.7933,
    y2: 22.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2093_6820",
    x1: 17.8322,
    y1: 21.3294,
    x2: 23.7882,
    y2: 20.5472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2093_6820",
    x1: 7.26245,
    y1: 8.18055,
    x2: 8.55432,
    y2: 29.5715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2093_6820",
    x1: 27.0363,
    y1: 15.05,
    x2: 18.5845,
    y2: 15.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2093_6820",
    x1: 27.0365,
    y1: 23.9815,
    x2: 18.5801,
    y2: 23.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2093_6820",
    x1: 27.0359,
    y1: 27.9852,
    x2: 18.5841,
    y2: 27.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2093_6820",
    x1: 17.4457,
    y1: 15.0916,
    x2: 21.848,
    y2: 14.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2093_6820",
    x1: 25.1438,
    y1: 24.0419,
    x2: 20.6565,
    y2: 24.0419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2093_6820",
    x1: 25.1433,
    y1: 27.9855,
    x2: 20.6559,
    y2: 27.9855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2093_6820",
    x1: 19.6665,
    y1: 14.9885,
    x2: 17.2722,
    y2: 14.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2093_6820",
    x1: 19.2356,
    y1: 15.0571,
    x2: 16.4821,
    y2: 15.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2093_6820",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5699 25.3585) rotate(23.5251) scale(3.36134 1.56063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2093_6820",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.741 15.0701) rotate(2.02718) scale(2.87602 1.88763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2093_6820",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6019 24.3382) rotate(-0.0544055) scale(3.08867 1.66503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2093_6820",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5332 28.0821) rotate(-0.0539601) scale(2.82793 1.76993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2093_6820",
    x1: 19.9533,
    y1: 23.9341,
    x2: 16.4831,
    y2: 23.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2093_6820",
    x1: 19.2154,
    y1: 23.812,
    x2: 17.3462,
    y2: 23.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2093_6820",
    x1: 19.8277,
    y1: 28.0076,
    x2: 15.7695,
    y2: 27.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2093_6820",
    x1: 19.4082,
    y1: 27.8746,
    x2: 17.6928,
    y2: 27.8746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2093_6820",
    x1: 22.143,
    y1: 14.5175,
    x2: 23.2339,
    y2: 19.7968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2093_6820",
    x1: 22.9716,
    y1: 24.9483,
    x2: 21.7815,
    y2: 20.6541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2093_6820",
    x1: 27.0361,
    y1: 19.8815,
    x2: 18.5843,
    y2: 19.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2093_6820",
    x1: 18.244,
    y1: 19.6456,
    x2: 24.7183,
    y2: 19.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7382,
    stopColor: "#FFD748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2093_6820",
    x1: 20.7698,
    y1: 19.7939,
    x2: 15.9328,
    y2: 19.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2093_6820",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5791 19.8038) rotate(-2.73606) scale(3.1626 2.07582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2093_6820",
    x1: 18.5215,
    y1: 19.7881,
    x2: 16.9943,
    y2: 19.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2093_6820",
    x1: 22.5446,
    y1: 19.323,
    x2: 23.4633,
    y2: 25.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2093_6820",
    x1: 21.9075,
    y1: 23.8395,
    x2: 24.2611,
    y2: 28.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2093_6820",
    x1: 21.4394,
    y1: 28.3197,
    x2: 21.7838,
    y2: 31.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2093_6820",
    x1: 21.5206,
    y1: 27.8302,
    x2: 21.5206,
    y2: 25.4952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2093_6820",
    x1: 5.75549,
    y1: 21.3835,
    x2: -1.56276,
    y2: 32.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2093_6820",
    x1: 5.27343,
    y1: 23.829,
    x2: 6.47912,
    y2: 29.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2093_6820",
    x1: 6.0019,
    y1: 24.8387,
    x2: 5.82962,
    y2: 31.4237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2093_6820",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2145 3.935) rotate(79.0714) scale(3.03246 1.77893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.8de6dab9b8590870cb5394fef08510fb.svg";
export { ForwardRef as ReactComponent };